import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

/**
 * Prosty serwis do zachowania pozycji scrollowania w dialogach
 * Bez ingerencji w style Material Design - tylko zapisuje i przywraca pozycję
 */
@Injectable({
  providedIn: 'root'
})
export class DialogScrollLockService implements OnDestroy {
  private subscription: Subscription | null = null;
  private scrollPosition = 0;
  private dialogCount = 0;

  constructor(private dialog: MatDialog) {
    this.init();
  }

  private init(): void {
    // Nasłuchuj na otwieranie dialogów
    this.subscription = this.dialog.afterOpened.subscribe(() => {
      this.dialogCount++;
      
      // Zapisz pozycję scrollowania TYLKO przy pierwszym dialogu
      if (this.dialogCount === 1) {
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Ręcznie zablokuj scroll - używamy position: fixed z top
        // To zapobiega scrollowaniu ale zachowuje pozycję
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
      }
    });

    // Nasłuchuj na zamykanie dialogów
    this.dialog.afterAllClosed.subscribe(() => {
      this.dialogCount = 0;
      
      // Zapisz pozycję przed odzblokowaniem scrolla
      const savedPosition = this.scrollPosition;
      
      // Odblokuj scroll i przywróć style
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
      // Przywróć pozycję scrollowania natychmiast po odblokowaniu
      window.scrollTo(0, savedPosition);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

